<mat-dialog-content class="contactfield-validation-wrapper" [formGroup]="validationForm">
  @if (validationType === emailValidationType) {
    <mat-form-field appearance="outline" class="subject">
      <mat-label>{{getValidationSubjectLabel()}}</mat-label>
      <input matInput type="email" name="email" formControlName="email" [readonly]="validationSent" #emailInputField (keydown.enter)="subjectEnterEvent()" />
      @if (validationSent === true) {
        <button mat-icon-button matIconSuffix (click)="changeSubject()">
          <span class="material-symbols-rounded">edit</span>
        </button>
      }
      @if (validationForm.controls['email'].hasError('required')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.RequiredField|Kötelező mező' | translate }}
        </mat-error>
      }
      @if (validationForm.controls['email'].hasError('email')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.Email|Érvénytelen email cím' | translate }}
        </mat-error>
      }
      @if (validationForm.controls['email'].hasError('trailingSpace')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.TrailingSpace|Kezdő és záró szóköz nem megengedett' | translate }}
        </mat-error>
      }
      @if (validationForm.controls['email'].hasError('uniqueness')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.UserAlreadyExists|Duplikáció, a felhasználó már létezik az adatbázisban' | translate }}
        </mat-error>
      }
    </mat-form-field>
  }
  @if (validationType === smsValidationType) {
    <mat-form-field appearance="outline" class="subject">
      <mat-label>{{getValidationSubjectLabel()}}</mat-label>
      <input matInput type="tel" name="phonenumber" formControlName="phonenumber" mask=" 00 000 0000" prefix="36" [readonly]="validationSent" #phoneNumberInputField (keydown.enter)="subjectEnterEvent()" />
      @if (validationSent === true) {
        <button mat-icon-button matIconSuffix (click)="changeSubject()">
          <span class="material-symbols-rounded">edit</span>
        </button>
      }
      @if (validationForm.controls['phonenumber'].hasError('mask')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.Mask.PhoneNumber|9 számjegy' | translate }}
        </mat-error>
      }
      @if (validationForm.controls['phonenumber'].hasError('required')) {
        <mat-error>
          {{ 'UI.Label.Common.Error.RequiredField|Kötelező mező' | translate }}
        </mat-error>
      }
    </mat-form-field>
  }
  @if (validationSent === true && validationForm.controls['confirmed'].value === false && validationError() === false) {
    <div class="instruction">
      <div class="mt-5">{{getInstructionLabel()}}</div>
    </div>
  }
  <div class="information" [class.validation]="validationSent === true">
    @if (validationError()) {
      <span>{{ 'UI.Label.Common.Error.ValidationError|Helytelen hitelesítő kód' | translate }}</span>
    }
    @if (validationSent === false || validationError()) {
      <button mat-raised-button class="validate-btn"
        [class.enabled]="validateButtonDisabled() === false"
        (click)="validate()"
        [disabled]="validateButtonDisabled()">
        {{getValidationButtonText()}}
      </button>
    }
    @if (validationSent === true && validationForm.controls['confirmed'].value === false && validationError() === false) {
      <div class="code-container">
        @if (validationSent === true && validationForm.controls['confirmed'].value === false) {
          <span class="mt-5">{{getCodePrefix()}}</span>
        }
        @if (validationSent === true && validationForm.controls['confirmed'].value === false) {
          <mat-form-field appearance="outline">
            <mat-label>{{'UI.Label.Validation.ValidationCodeLabel|Kód' | translate}}</mat-label>
            <input matInput type="number" name="validationCode" formControlName="validationCode" #validationCodeInput (keydown.enter)="validationCodeEnterEvent()" />
            @if (validationForm.controls['validationCode'].hasError('invalidCode')) {
              <mat-error>
                {{ 'UI.Label.Common.Error.ValidationError|Érvénytelen kód.' | translate }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (validationSent === true && validationForm.controls['confirmed'].value === false) {
          <button mat-raised-button matTextSuffix class="validate-ok-btn mt-5" [disabled]="validationForm.controls['validationCode'].invalid"
            [class.enabled]="validationForm.controls['validationCode'].valid"
            (click)="submitValidationCode()">
            {{'UI.Label.Validation.SubmitValidationCode|OK' | translate}}
          </button>
        }
      </div>
    }
    @if (validationSent === true && validationForm.controls['confirmed'].value === true) {
      <div class="validated-btn">
        <span class="material-symbols-rounded">check</span>
        {{'UI.Label.Validation.ValidatedLabel|Hitelesítve' | translate}}
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [mat-dialog-close]="validationForm" [disabled]="!validationForm.valid">{{ 'UI.Label.Common.Ok|Ok' | translate }}</button>
</mat-dialog-actions>

